package ir.yusefpasha.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.components.style.toModifier
import ir.yusefpasha.models.Theme
import ir.yusefpasha.style.InputStyle
import ir.yusefpasha.style.MainButtonStyle
import ir.yusefpasha.util.Constants
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun ContactForm(breakpoint: Breakpoint) {
    Form(
        action = Constants.FORM_ACTION_URL,
        attrs = Modifier
            .attrsModifier {
                attr("method", "POST")
            }
            .toAttrs()
    ) {
        // Name
        Label(
            attrs = Modifier
                .classNames("form-label")
                .toAttrs(),
            forId = "inputName"
        ) {
            Text("Name")
        }
        Input(
            type = InputType.Text,
            attrs = InputStyle.toModifier()
                .id("inputName")
                .classNames("form-control")
                .boxShadow(0.px, 0.px, 0.px, 0.px, null)
                .margin(bottom = 15.px)
                .width(
                    if (breakpoint >= Breakpoint.MD) 500.px else 250.px
                )
                .backgroundColor(Theme.LighterGray.rgb)
                .attrsModifier {
                    attr("placeholder", "Full Name")
                    attr("required", "true")
                    attr("name", "name")
                }
                .toAttrs()
        )

        // Email
        Label(
            attrs = Modifier
                .classNames("form-label")
                .toAttrs(),
            forId = "inputEmail"
        ) {
            Text("Email")
        }
        Input(
            type = InputType.Email,
            attrs = InputStyle.toModifier()
                .id("inputEmail")
                .classNames("form-control")
                .boxShadow(0.px, 0.px, 0.px, 0.px, null)
                .margin(bottom = 15.px)
                .width(
                    if (breakpoint >= Breakpoint.MD) 500.px else 250.px
                )
                .backgroundColor(Theme.LighterGray.rgb)
                .attrsModifier {
                    attr("placeholder", "Email Address")
                    attr("required", "true")
                    attr("name", "email")
                }
                .toAttrs()
        )

        // Message
        Label(
            attrs = Modifier
                .classNames("form-label")
                .toAttrs(),
            forId = "inputMessage"
        ) {
            Text("Message")
        }
        TextArea(
            attrs = InputStyle.toModifier()
                .id("inputMessage")
                .classNames("form-control")
                .height(150.px)
                .maxHeight(250.px)
                .boxShadow(0.px, 0.px, 0.px, 0.px, null)
                .margin(bottom = 25.px)
                .width(
                    if (breakpoint >= Breakpoint.MD) 500.px else 250.px
                )
                .backgroundColor(Theme.LighterGray.rgb)
                .attrsModifier {
                    attr("placeholder", "Your Message")
                    attr("required", "true")
                    attr("name", "message")
                }
                .toAttrs()
        )

        // Button
        Box(
            modifier = Modifier.fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            Button(
                attrs = MainButtonStyle.toModifier()
                    .height(40.px)
                    .border(width = 0.px)
                    .borderRadius(r = 5.px)
                    .backgroundColor(Theme.Primary.rgb)
                    .color(Colors.White)
                    .cursor(Cursor.Pointer)
                    .toAttrs()
            ) {
                Text("Submit")
            }
        }
    }
}

@Composable
private fun Contact() {

}